import { ThemeProvider } from '@emotion/react';
import { UserProvider } from 'features/user/context';
import { History, MemoryHistory } from 'history';
import React, { ReactNode } from 'react';
import { QueryClientProvider } from 'react-query';
import { Router } from 'react-router-dom';
import {
  LayoutProvider,
  PromptProvider,
  queryClient,
  SignalrContextProvider,
} from 'stores';
import { xTheme } from 'styles';
import { AntdProvider } from './AntdProvider';
import { XAuthProvider } from './XAuthProvider';

type RouterProviderProps = {
  children: ReactNode;
  history: MemoryHistory | History;
};

export function AppProviders({
  children,
  history,
}: RouterProviderProps): React.JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={xTheme}>
        <AntdProvider>
          <XAuthProvider>
            <Router history={history}>
              <LayoutProvider>
                <UserProvider>
                  <SignalrContextProvider>
                    <PromptProvider>{children}</PromptProvider>
                  </SignalrContextProvider>
                </UserProvider>
              </LayoutProvider>
            </Router>
          </XAuthProvider>
        </AntdProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
